export enum CharacterType {
    LEADER = "LEADER",
    MAJOR = "MAJOR",
    IMPORTANT = "IMPORTANT",
    MINOR = "MINOR",
}

export enum CodexEntryCategory {
    UNIT = "UNIT",
    WEAPON = "WEAPON",
    WARGEAR = "WARGEAR",
    VEHICLE = "VEHICLE",
    VESSEL = "VESSEL",
    CONFLICT = "CONFLICT",
    LOCATION = "LOCATION",
}

export enum ImageSize {
    SMALL = "SMALL",
    MEDIUM = "MEDIUM",
    LARGE = "LARGE",
}
